/**
 * Fixed-position footer strip at the bottom of the viewport. Click the
 * "Terms & Conditions" link to open the full T&C modal. Ported from v2
 * (web/src/components/TermsFooter.tsx) — same content, V3-shaped imports.
 */
import { useState } from "react";
import { Box, Button, Header, Modal } from "@cloudscape-design/components";
import { TermsBody } from "./TermsContent";

export function TermsFooter() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="terms-footer-fixed">
        <span>
          © {new Date().getFullYear()} Sigon Group LLC. By using SOC1.lab you acknowledge the{" "}
          <button type="button" className="terms-footer-link" onClick={() => setOpen(true)}>
            Terms &amp; Conditions
          </button>
          .
        </span>
      </div>

      <Modal
        visible={open}
        onDismiss={() => setOpen(false)}
        header={<Header variant="h2">SOC1.lab — Terms &amp; Conditions</Header>}
        size="large"
        footer={
          <Box float="right">
            <Button variant="primary" onClick={() => setOpen(false)}>
              I acknowledge
            </Button>
          </Box>
        }
      >
        <TermsBody />
      </Modal>
    </>
  );
}
